export const companyDynamic = ({
  commit,
  state
}, companyDynamic) => {
  commit('DYNAMIC', companyDynamic)
}
export const companyDynamicImg = ({
  commit,
  state
}, companyDynamicImg) => {
  commit('DYNAMICIMG', companyDynamicImg)
}
export const dynamicTotal = ({
  commit,
  state
}, dynamicTotal) => {
  commit('DTOTAL', dynamicTotal)
}
export const mediaReport = ({
  commit,
  state
}, mediaReport) => {
  commit('REPORT', mediaReport)
}
export const mediaReportImg = ({
  commit,
  state
}, mediaReportImg) => {
  commit('REPORTIMG', mediaReportImg)
}
export const reportTotal = ({
  commit,
  state
}, reportTotal) => {
  commit('RTOTAL', reportTotal)
}
export const socialBenefit = ({
  commit,
  state
}, socialBenefit) => {
  commit('BENEFIT', socialBenefit)
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js